/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BackupHistoryDto } from '../models/BackupHistoryDto';
import type { RestoreDto } from '../models/RestoreDto';
import type { RestoreHistoryDto } from '../models/RestoreHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DomainRestoreControllerService {

    /**
     * @param name
     * @returns RestoreDto OK
     * @throws ApiError
     */
    public static getDomainRestoreSchedule(
        name: string,
    ): CancelablePromise<RestoreDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains/{name}/restore',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns RestoreDto Created
     * @throws ApiError
     */
    public static createDomainRestoreSchedule(
        name: string,
        requestBody: RestoreDto,
    ): CancelablePromise<RestoreDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/domains/{name}/restore',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteDomainRestoreSchedule(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/domains/{name}/restore',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns BackupHistoryDto OK
     * @throws ApiError
     */
    public static getDomainRestoreFiles(
        name: string,
    ): CancelablePromise<Array<BackupHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains/{name}/restore/listFiles',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns RestoreHistoryDto OK
     * @throws ApiError
     */
    public static getDomainRestoreHistory(
        name: string,
    ): CancelablePromise<Array<RestoreHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains/{name}/restore/history',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
